import { Box, Grid, Typography } from "@mui/material";
import { ProfileProductCard } from "../product/ProfileProductCard";
import { ResultsWithFilter } from "../product/ResultsWithFilter";

import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";

interface IPurchaseProps {}

export const Purchase: React.FC<IPurchaseProps> = ({}) => {
  // dummy handlers
  const handleViewOrder = (productId: number) => {
    console.log("View order details:", productId);
  };

  const handleTrackPackage = (productId: number) => {
    console.log("Track package:", productId);
  };

  const handleContactSeller = (productId: number) => {
    console.log("Contact seller for product:", productId);
  };

  const handleLeaveReview = (productId: number) => {
    console.log("Leave review for product:", productId);
  };

  return (
    <Box>
      <Grid container justifyContent="space-between" alignItems="center" pb={2}>
        <Grid item>
          <Typography variant="h6" fontWeight="bold">
            My Purchases
          </Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" spacing={1} wrap="nowrap">
            <ResultsWithFilter
              menuItems={[
                { label: "Filter by:", value: "", isDisabled: true },
                { label: "Recent", value: "Recent" },
                { label: "Oldest", value: "Oldest" },
              ]}
              filterHandler={() => {}}
              defaultValue="Recent"
              totalResults={0}
            />
          </Grid>
        </Grid>
      </Grid>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
        sx={{ color: "text.secondary" }}
      >
        <Typography variant="h6" textAlign="center">
          You haven't purchased anything yet.
        </Typography>
      </Box>
    </Box>
  );
};
